import React from 'react';

type Variant = 'primary' | 'blue' | 'secondary' | 'ghost' | 'danger';
type Size = 'lg' | 'md' | 'sm' | 'xs' | 'icon';

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  size?: Size;
  block?: boolean;
};

const variantClass: Record<Variant, string> = {
  primary: 'btn-primary',
  blue: 'btn-blue',
  secondary: 'btn-secondary',
  ghost: 'btn-ghost',
  danger: 'btn-danger',
};

const sizeClass: Record<Size, string> = {
  lg: 'btn-lg',
  md: '',
  sm: 'btn-sm',
  xs: 'btn-xs',
  icon: 'btn-icon',
};

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'secondary', size = 'md', block, className = '', type = 'button', ...rest }, ref) => {
    const cls = ['btn', variantClass[variant], sizeClass[size], block ? 'btn-block' : '', className]
      .filter(Boolean)
      .join(' ');
    return <button ref={ref} type={type} className={cls} {...rest} />;
  }
);

Button.displayName = 'Button';
